import WorkOutlinedIcon from "@mui/icons-material/WorkOutlined";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { useHospitalData } from "../../contexts/HospitalDataProvider";
import { INK } from "../../theme/tokens";
import { isAgencyNurse } from "../../utils/utilFunctions";
import { InHouseTooltip } from "../InHouseTooltip/InHouseTooltip";

export const NurseAgencyIndicator: FC<{ nurseId: number }> = ({ nurseId }) => {
	const { getNurseById } = useHospitalData();
	const { t } = useTranslation();

	const nurse = getNurseById(nurseId);
	if (!nurse || (!nurse.agencyName && !isAgencyNurse(nurse.employmentType))) {
		return null;
	}

	return (
		<InHouseTooltip title={nurse.agencyName || t("agency")}>
			<WorkOutlinedIcon data-testid="nurse-agency-indicator" sx={{ fontSize: { xs: 12, sm: 14 }, color: INK.SECONDARY }} />
		</InHouseTooltip>
	);
};
